module.exports = "../../../../platform/assets/pageMainIcon/business_baobiaochaxunlei4.svg";